export default __webpack_public_path__ + "static/media/iab-funnel-shared.98aa6121.svg";